"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdverseMediaScreeningDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdverseMediaScreeningDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.adverse_media_screening_description.label',
    fallbackLabel: 'Please elaborate on the situations in which adverse media screening is necessary, outline the actions taken if the screening reveals risks that are deemed unacceptable and provide insights into which media screening results are deemed unacceptable by your company.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adverse_media_screening', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adverse_media_screening === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adverse_media_screening === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
